import React, { useEffect, useState } from 'react';
import { Tooltip, Modal } from 'antd';
import * as Yup from 'yup';
import { UploadFile, Visibility } from '@app/components';
import { Button, FormDatePicker, FormSelect, FormSubmitButton, MasterDetailForm, Row } from '@digital/ui';
import { ISasPropostaOrdemCompra, ISasPropostaOrdemCompraDocs, updateEnvioConfide } from '@app/api/sas/sasProposta';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { editandoState, modalAcoesIdState, reloadVendorListState, vendorListDocsState } from '../atoms';
import { isObjNotEmpty, vtObjToFormData } from '@app/helpers/objHelper';
import { IArquivo } from '@app/types/core.types';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';

interface Props {
    sasProposta: ISasPropostaOrdemCompra;
}


const ModalEnviarConfide = ({ sasProposta }: Props) => {

    const setModalAcoesId = useSetRecoilState(modalAcoesIdState);
    const setReloadVendorList = useSetRecoilState(reloadVendorListState);
    const editando = useRecoilValue(editandoState);
    const vendorListDocs = useRecoilValue(vendorListDocsState);

    const [exibirModal, setExibirModal] = useState(false);
    const [doc, setDoc] = useState<ISasPropostaOrdemCompraDocs>({} as ISasPropostaOrdemCompraDocs);

    useEffect(() => {
        var doc = vendorListDocs.find(f => f.id == sasProposta.id);
        if (isObjNotEmpty(doc)) {
            setDoc(doc || {} as ISasPropostaOrdemCompraDocs);
        }
    }, [exibirModal]);


    const handleCancel = () => {
        setExibirModal(false);
    };

    const handleCancelAndClose = () => {
        setExibirModal(false);
        setModalAcoesId('');
    };

    const handleSuccess = () => {
        setReloadVendorList((v: boolean) => !v);
        handleCancelAndClose();
    };

    const handleSubmit = (values: any) => {
        const form = vtObjToFormData(values);

        Modal.confirm({
            title: '',
            content: `Confirma o envio do Relatório Financeiro ?`,
            cancelText: 'Cancelar',
            onCancel: () => { },
            okText: 'Confirmar',
            onOk: () => {

                if (editando.sasPropostaId == sasProposta.id) {
                    Modal.confirm({
                        title: <>{editando.justificativa}</>,
                        content: <ModalConfirmContentJustificativa
                            texto='É necessário informar a justificativa para a alteração.'
                            setJustificativa={e => {
                                form.set('justificativaEdicao', e);
                            }}
                        />,
                        okText: 'Confirmar',
                        cancelText: 'Cancelar',
                        onOk: async (e) => {
                            form.append('editando', 'true');
                            return new Promise((resolve, reject) => {
                                updateEnvioConfide(form)
                                    .then((data: any) => {
                                        if (data && data.valid) {
                                            handleSuccess();
                                            return resolve(true);
                                        } else {
                                            if (data.notifications && data.notifications.length > 0) {
                                                const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                                    return c.property == 'justificativaEdicao';
                                                });
                                                if (erroJustificativaEdicao >= 0) {
                                                    return reject(false);
                                                }
                                            }
                                        }
                                    });
                            });
                        },
                        onCancel: handleCancelAndClose
                    });
                } else {
                    updateEnvioConfide(form)
                        .then((data: any) => {
                            if (data && data.valid) {
                                handleSuccess();
                            }
                        });
                }
            }
        });
    };

    return (
        <>
            <Tooltip title="Enviar Relatório Financeiro">
                <Button type='primary' icon='business-set_as_resume' onClick={() => { setExibirModal(true); }} />
            </Tooltip>

            <Visibility visible={exibirModal}>

                <Modal
                    title={`Enviar Relatório Financeiro`}
                    width='780px'
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <Visibility visible={isObjNotEmpty(sasProposta) && exibirModal} >
                        <MasterDetailForm
                            key={`formEnvioConfide_${sasProposta.id}`}
                            actions={[
                                <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                                <Visibility visible={
                                    sasProposta.statusResultadoEnvioConfide !== "Enviado" ||
                                    editando.sasPropostaId == sasProposta.id
                                }>
                                    <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                                </Visibility>
                            ]}
                            initialValues={{
                                sasPropostaId: sasProposta.id,
                                ordemCompraId: sasProposta.ordemCompraId,
                                statusResultadoEnvioConfide: sasProposta.statusResultadoEnvioConfide,
                                dataResultadoEnvioConfide: sasProposta.dataResultadoEnvioConfide,
                            }}
                            validationSchema={
                                Yup.object().shape({
                                    dataResultadoEnvioConfide: Yup.string().required(`O campo Data de Envio é obrigatório.`),
                                    arquivo: Yup.mixed().required('É necessário anexar um arquivo.')
                                })
                            }
                        >
                            <Row style={{ paddingBottom: '16px' }}>
                                <FormSelect
                                    label='Status'
                                    name='statusResultadoEnvioConfideShow'
                                    value={sasProposta.statusResultadoEnvioConfide ? sasProposta.statusResultadoEnvioConfide : "Não Enviado"}
                                    options={[
                                        { text: 'Não Enviado', value: 'Não Enviado' },
                                        { text: 'Enviado', value: 'Enviado' }
                                    ]}
                                    span={6}
                                    disabled
                                />

                                <FormDatePicker
                                    format='DD/MM/YYYY'
                                    name='dataResultadoEnvioConfide'
                                    label='Data de Envio'
                                    required
                                    span={6}
                                    disabled={
                                        sasProposta.statusResultadoEnvioConfide == 'Enviado' &&
                                        editando.sasPropostaId !== sasProposta.id
                                    }
                                />
                            </Row>
                            <Row>

                                <UploadFile
                                    idDoComponente='anexoEnvioConfide'
                                    type='primary'
                                    hasLabel={true}
                                    icon='ui-upload'
                                    span={6}
                                    onGetArquivo={() => {

                                        if (isObjNotEmpty(doc.anexoEnvioConfide)) {
                                            return Promise.resolve({
                                                id: doc.anexoEnvioConfide.id,
                                                nome: doc.anexoEnvioConfide.nome,
                                                status: "",
                                                statusArquivoId: doc.anexoEnvioConfide.statusArquivoId || "",
                                            } as IArquivo);
                                        }
                                        return Promise.resolve(undefined);

                                    }}
                                    showDownload={isObjNotEmpty(doc.anexoEnvioConfide)}
                                    showUpload={sasProposta.statusResultadoEnvioConfide !== 'Enviado'
                                        || editando.sasPropostaId === sasProposta.id
                                    }
                                />

                            </Row>
                        </MasterDetailForm>
                    </Visibility>
                </Modal>

            </Visibility>

        </>
    );
};

export default ModalEnviarConfide;